exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.w-full[data-v-77b1ac2a] {\n  width: 400px;\n}\n.twilio-btn[data-v-77b1ac2a] {\n  width: 110px;\n  background: #fff;\n}\n.twilio-logo-red[data-v-77b1ac2a] {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 90px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77b1ac2a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/settings/SettingsPhoneNumbers.vue
// module id = yQW0
// module chunks = 0